import React, { useMemo } from 'react';
import styled from 'styled-components';
import { typographyMixin, FONT_TYPES, ZillowLogo } from '@zillow/constellation';
import {
  BrandType,
  useBrandContext,
} from 'zdocs-web-core/components/BrandProvider';
import ShowingTimePlusLogo from 'zdocs-web-core/components/ShowingTimePlusLogo';

export const HEADER_HEIGHT = '4rem';

const MainHeader = styled.header<{ showOnMobile: boolean }>`
  display: ${props => (props.showOnMobile ? 'flex' : 'none')};
  align-items: center;
  padding: 0 2rem;
  height: ${HEADER_HEIGHT};
  background-color: ${props => props.theme.constellation.colors.white};
  border-bottom: 1px solid ${props => props.theme.constellation.colors.gray300};
  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    display: flex;
  }
`;

const HeaderLeft = styled.div`
  flex: 0 0 40%;
  width: 40%;
`;

const HeaderCenter = styled.div`
  display: flex;
  justify-content: center;
  flex: 0 0 20%;
  width: 20%;
  color: ${props => props.theme.constellation.colors.blue400};
`;

const HeaderRight = styled.div`
  flex: 0 0 40%;
  width: 40%;
  text-align: right;
  ${props =>
    typographyMixin({ ...props, fontType: FONT_TYPES.bodySmallHeading })};
`;

const StyledLogo = styled.svg`
  height: 1.5rem;
`;

interface Props {
  name?: string;
  showOnMobile?: boolean;
}

export function Header({ name, showOnMobile = false }: Props) {
  const brand = useBrandContext();
  const logo = useMemo(() => {
    if (brand.type === BrandType.SHOWING_TIME_PLUS) {
      return ShowingTimePlusLogo;
    }

    return ZillowLogo;
  }, [brand.type]);

  return (
    <MainHeader showOnMobile={showOnMobile}>
      <HeaderLeft />
      <HeaderCenter>
        <StyledLogo as={logo} />
      </HeaderCenter>
      <HeaderRight>{name}</HeaderRight>
    </MainHeader>
  );
}
